export const MODEL_ROUTE = '/stocking-batches';
